import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';

const PrivacyPage: React.FC = () => {
  return (
    <Container maxWidth="lg">
      <Paper elevation={3} sx={{ p: 4, my: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            1. Introduction
          </Typography>
          <Typography paragraph>
            Welcome to our Privacy Policy. This document explains how we collect, use, and protect your personal information when you use our service.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            2. Information We Collect
          </Typography>
          <Typography paragraph>
            We collect information you provide directly to us, such as when you create an account, upload content, or communicate with us.
            This may include your name, email address, location data, and photos.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            3. How We Use Your Information
          </Typography>
          <Typography paragraph>
            We use your information to provide and improve our services, process your requests, communicate with you,
            and understand how users interact with our platform.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            4. Data Sharing and Disclosure
          </Typography>
          <Typography paragraph>
            We do not sell your personal information. We may share information with third-party service providers 
            who help us operate our services, with your consent, or as required by law.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            5. Data Security
          </Typography>
          <Typography paragraph>
            We implement appropriate security measures to protect your personal information from unauthorized access, 
            alteration, disclosure, or destruction.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            6. Your Rights
          </Typography>
          <Typography paragraph>
            Depending on your location, you may have certain rights regarding your personal information, 
            such as the right to access, update, or delete your data.
          </Typography>
        </Box>
        
        <Box sx={{ my: 3 }}>
          <Typography variant="h5" gutterBottom>
            7. Changes to This Policy
          </Typography>
          <Typography paragraph>
            We may update this Privacy Policy from time to time. We will notify you of any changes by posting 
            the new Privacy Policy on this page and updating the "Last Updated" date.
          </Typography>
        </Box>
        
        <Box sx={{ mt: 4 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Last Updated: {new Date().toLocaleDateString()}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPage; 